import { motion } from "framer-motion";

const CHAPTERS = [
  { n: "01", title: "Schnell", text: "Telefonisch vorbestellt, zehn Minuten später fertig zur Abholung. So geht Imbiss." },
  { n: "02", title: "Sauber", text: "Ein gepflegter Laden, frische Zutaten, selbstgemachte Salate und Tzatziki." },
  { n: "03", title: "Freundlich", text: "Ein Team, das seine Stammgäste kennt — und neue Gäste wie alte Freunde begrüßt." },
  { n: "04", title: "Geschmackvoll", text: "Großzügige Portionen, ehrliche Preise und Gyros, das man in Siegen kennt." },
];

export const Manifesto = () => (
  <section data-testid="manifesto-section" className="relative z-10 py-24 md:py-36">
    <div className="mx-auto grid max-w-7xl grid-cols-1 gap-14 px-5 md:grid-cols-12 md:px-10">
      <div className="md:col-span-5">
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.6, ease: "easeOut" }}
          className="mb-6 text-xs font-bold uppercase tracking-[0.28em] text-[#78825B]"
        >
          Unser Versprechen
        </motion.p>
        <motion.blockquote
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.7, delay: 0.1, ease: "easeOut" }}
          className="font-display text-3xl font-light leading-snug tracking-tight text-[#1A1C19] sm:text-4xl"
          data-testid="manifesto-quote"
        >
          „Griechische Spezialitäten wie Gyros und Co.{" "}
          <span className="italic text-[#4B7F94]">Seit 1985 in Siegen.</span>{" "}
          Schnell, sauber, freundlich … geschmackvoll."
        </motion.blockquote>
        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.25 }}
          className="mt-6 text-xs font-semibold uppercase tracking-[0.2em] text-[#4A4D46]"
        >
          — Ihr Tsolias Team
        </motion.p>
      </div>
      <div className="md:col-span-6 md:col-start-7">
        {CHAPTERS.map((c, i) => (
          <motion.div
            key={c.n}
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.6, delay: i * 0.08, ease: "easeOut" }}
            className="group flex gap-6 border-b border-[#E2E0D8] py-7 first:border-t"
            data-testid={`manifesto-chapter-${c.n}`}
          >
            <span className="font-display text-sm italic text-[#78825B]">{c.n}</span>
            <div>
              <h3 className="font-display text-xl tracking-tight text-[#1A1C19] transition-colors duration-300 group-hover:text-[#4B7F94] md:text-2xl">
                {c.title}
              </h3>
              <p className="mt-2 max-w-md text-base leading-relaxed text-[#3D403A]">{c.text}</p>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
